/**
 * Rollup of all payment transactions tied to an appointment.
 * Persisted on the appointment row in calendar_db, kept in sync by
 * payment-service via the {@code updateAppointmentPaymentStatus}
 * GraphQL mutation after every transaction write.
 */
export type AppointmentPaymentStatus =
    | 'NOT_PAID'
    | 'PENDING'
    | 'CONVENIO_PENDING'
    | 'PARTIAL_PAID'
    | 'PAID'
    | 'PARTIALLY_REFUNDED'
    | 'REFUNDED'
    | 'CANCELED';

/** Display copy + tone for the Payment tab badge / "Already paid" card. */
export const APPOINTMENT_PAYMENT_LABEL: Record<
    AppointmentPaymentStatus,
    { label: string; tone: 'paid' | 'partial' | 'pending' | 'refunded' | 'failed' | 'unpaid' | 'convenio' }
> = {
    PAID:               { label: 'Paid',           tone: 'paid' },
    PARTIAL_PAID:       { label: 'Partial Paid',   tone: 'partial' },
    PARTIALLY_REFUNDED: { label: 'Partial refund', tone: 'partial' },
    PENDING:            { label: 'Pending',        tone: 'pending' },
    CONVENIO_PENDING:   { label: 'Convênio a receber', tone: 'convenio' },
    REFUNDED:           { label: 'Refunded',       tone: 'refunded' },
    CANCELED:           { label: 'Canceled',       tone: 'failed' },
    NOT_PAID:           { label: 'Not Paid',       tone: 'unpaid' },
};
